import safeRegex from 'safe-regex';

const MAX_PATTERN_LENGTH = 200;
const STAR_HEIGHT_LIMIT = 25;

const isRegexPattern = (original) =>
    original.includes("^") ||
    original.includes("*") ||
    original.includes("?") ||
    original.includes("$");

const buildRegexSource = (original) => {
    let parsed = original.includes("*")
        ? original.replaceAll(".*", "*").replaceAll("*", ".*")
        : original;
    if (!parsed.includes("$")) parsed = `${parsed}$`;
    if (!parsed.startsWith("^")) parsed = `^${parsed}`;
    return parsed;
};

export const validateOriginalPattern = (original) => {
    if (!original || !isRegexPattern(original)) return null;

    if (original.length > MAX_PATTERN_LENGTH) {
        return `Kuvio on liian pitkä (${original.length}/${MAX_PATTERN_LENGTH} merkkiä).`;
    }

    const source = buildRegexSource(original);

    try {
        new RegExp(source, 'i');
    } catch (err) {
        return `Virheellinen regex-syntaksi: ${err.message}`;
    }

    if (!safeRegex(source, { limit: STAR_HEIGHT_LIMIT })) {
        return "Vaarallinen regex-kuvio (sisäkkäiset kvanttorit tai haarojen päällekkäisyys). Lambda voi hyytyä pyyntöön.";
    }

    return null;
};

export const scanRulesForRisky = (rules) => {
    const risky = new Set();
    if (!rules) return risky;
    for (const rule of rules) {
        if (validateOriginalPattern(rule.original)) {
            risky.add(rule.id);
        }
    }
    return risky;
};
